module.exports = __webpack_public_path__ + "static/huayra-9fd78340a037bec8550e4ed956e7993b.jpg";